<script setup>
import AuditCard from './AuditCard.vue'
import JsonDetails from './JsonDetails.vue'
import { useAuditText } from './audit-text.js'

defineProps({
  snapshot: { type: Object, required: true },
  // 快照里冻结并经引擎规范化的作品内容，含隐藏设定。
  pack: { type: Object, required: true },
})

const { tr } = useAuditText()
</script>

<template>
  <AuditCard :title="tr('raw.title')" :hint="tr('spoilerNotice')" data-testid="observer-raw">
    <JsonDetails :label="tr('raw.pack')" :value="pack" />
    <JsonDetails :label="tr('raw.snapshot')" :value="snapshot" :note="tr('raw.contextNote')" />
    <JsonDetails :label="tr('raw.requests')" :value="snapshot.requests ?? {}" />
  </AuditCard>
</template>
